module.exports = __webpack_public_path__ + "4d8dd551.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Payout/PayoutForm/paypal.png
// module id = 992
// module chunks = 15